<template>
  <div
    :aria-pressed="hoverButtonActiveState === 'active'"
    class="hovered-button"
    :class="{ active: hoverButtonActiveState === 'active' }"
    role="button"
    :tabindex="disabled ? -1 : 0"
    @click="onClick"
    @keydown.enter="onClick"
    @keydown.space="onClick"
  >
    <div
      class="hover-header"
      :class="{
        active: hoverButtonActiveState === 'active',
        disabled: disabled
      }"
    >
      {{ hoverButtonTitle }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonSquareHoverButton',
  props: {
    hoverButtonActiveState: {
      type: String,
      default: 'inactive',
      validator: (value) => {
        return ['inactive', 'active'].indexOf(value) !== -1
      }
    },
    hoverButtonTitle: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['onHoverButtonClick'],
  methods: {
    onClick() {
      if (this.disabled) return
      this.$emit('onHoverButtonClick')
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/variables.scss';

.hovered-button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  width: 60px;
}
.hover-header {
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: $box-shadow-overview-button;
  border-radius: 4px;
  padding: 5px;
  font-size: 14px;
  text-align: center;
  overflow: visible;
  background-color: $color-grey-lighter;
  color: $color-text-grey;
  min-width: 130px;
  cursor: pointer;
  &:hover {
    background-color: $color-grey-blue-dark;
    color: $color-text-white-70;
  }
}
.active {
  background-color: $color-grey-darker;
  color: $color-text-white-70;
}

.disabled {
  cursor: not-allowed;
  background-color: $color-grey;
  color: $color-text-white-70;
  &:hover {
    background-color: $color-grey;
    color: $color-text-white-70;
  }
}
@media screen and (max-width: 1024px) {
  .hover-header {
    min-width: 100px;
  }
}
</style>
